import React, { useEffect, useState, useContext } from "react";
import useMediaQuery from '@mui/material/useMediaQuery';

export const Guests = (props) => {
    const [sectionMarginTop, setSectionMarginTop] = useState('');
    const notMobile = useMediaQuery('(min-width:992px)');

    useEffect(() => {
        if (notMobile) {
            let rowPaddingGuest = document.querySelector('.box-guests').getBoundingClientRect().height;
            setSectionMarginTop((rowPaddingGuest + 80) + "px");
        }
    }, [notMobile]);


    return (
        <>
            {props.cultureCode === "en-us" &&
                <div className="container-fluid bkg-guests">
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">A cut above the rest</h2>
                                <img src="images/Infynito80/guests/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative">
                                <div className="box box-guests">
                                    <h3 className="mb-3">Guest Area</h3>
                                    <p><strong>Owner's Suite and Guest Cabins</strong>: The lower deck features the owner's suite, a VIP cabin, and two guest cabins, with a total of four bathrooms. The owner's cabin, located midship, boasts numerous closets and an open-plan bathroom.</p>

                                    <div className="d-block d-lg-none">
                                        <h3 className="mb-3">Crew quarter</h3>
                                        <p>With 3 berths distributed across 2 cabins, INFYNITO 80 also provides comfort for the crew. The crew's bathroom is located near a convenient laundry column.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 position-relative" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-guest pin-animation" />
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-owner pin-animation" />
                                <span data-aos="zoom-in" data-aos-delay="2500">
                                    <img src="images/Infynito80/pin-dark.svg" alt="" className="pin pin-crew pin-animation" />
                                </span>
                                <img src="images/Infynito80/lower-deck.png" alt="" className="lower-deck-guests w-100" />
                                <div className="box box-crew d-none d-lg-block" data-aos="fade-left" data-aos-duration="1500" data-aos-delay="2500">
                                    <h3 className="mb-3">Crew quarter</h3>
                                    <p>With 3 berths distributed across 2 cabins, INFYNITO 80 also provides comfort for the crew. The crew's bathroom is located near a convenient laundry column.</p>
                                </div>

                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}>
                        </div>
                    </div>
                </div>
            }
            {props.cultureCode === "it-it" &&
                <div className="container-fluid bkg-guests">
                    <div className="container py-5">
                        <div className="row justify-content-center">
                            <div className="col-md-10 text-center pt-5" data-aos="zoom-in">
                                <h2 className="text-uppercase mb-3 text-white">Spazi senza paragoni</h2>
                                <img src="images/Infynito80/guests/main.jpg" alt="" className="w-100" />
                            </div>
                            <div className="col-lg-6 position-relative">
                                <div className="box box-guests">
                                    <h3 className="mb-3">Area ospiti</h3>
                                    <p><strong>Suite Armatoriale e Cabine Ospiti</strong>: il ponte inferiore ospita una suite armatoriale, una cabina VIP e due cabine ospiti, con un totale di 4 bagni. La cabina armatoriale, situata a centro barca, dispone di numerosi armadi e un bagno open-plan.</p>

                                    <div className="d-block d-lg-none">
                                        <h3 className="mb-3">Area Equipaggio</h3>
                                        <p>Con 3 posti letto distribuiti su 2 cabine, INFYNITO 80 offre comfort anche per l'equipaggio. Il bagno dell'equipaggio è situato vicino a una comoda colonna lavanderia.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 position-relative" data-aos="fade-up" data-aos-duration="1500">
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-guest pin-animation" />
                                <img src="images/Infynito80/pin.svg" alt="" className="pin pin-owner pin-animation" />
                                <span data-aos="zoom-in" data-aos-delay="2500">
                                    <img src="images/Infynito80/pin-dark.svg" alt="" className="pin pin-crew pin-animation" />
                                </span>
                                <img src="images/Infynito80/lower-deck.png" alt="" className="lower-deck-guests w-100" />
                                <div className="box box-crew d-none d-lg-block" data-aos="fade-left" data-aos-duration="1500" data-aos-delay="2500">
                                    <h3 className="mb-3">Area Equipaggio</h3>
                                    <p>Con 3 posti letto distribuiti su 2 cabine, INFYNITO 80 offre comfort anche per l'equipaggio. Il bagno dell'equipaggio è situato vicino a una comoda colonna lavanderia.</p>
                                </div>

                            </div>
                        </div>
                        <div className="row pb-lg-5" style={{ marginTop: sectionMarginTop }}>
                        </div>
                    </div>
                </div>
            }

        </>
    );




};

export default Guests;